import { render, staticRenderFns } from "./DiscussionPanel.vue?vue&type=template&id=7d97445c&"
import script from "./DiscussionPanel.vue?vue&type=script&lang=js&"
export * from "./DiscussionPanel.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionPanel.vue?vue&type=style&index=0&id=7d97445c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports